import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { HEADER_DATA_SOURCE } from '../../../externals';
import { useMutation } from '@apollo/client';
import { SET_ONBOARDING_FIRST_STEP_SHOWN } from './onboardingOperations';
import { logGQLErrors } from '../../../shared/logGQLErrors';
export var useSetOnboardingFirstStepShown = function useSetOnboardingFirstStepShown() {
  var _useMutation = useMutation(SET_ONBOARDING_FIRST_STEP_SHOWN, {
    context: _defineProperty({}, HEADER_DATA_SOURCE, true),
    onError: function onError(error) {
      return logGQLErrors('Header - Set onboarding first step shown failed', error);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      setOnboardingFirstStepShown = _useMutation2[0];

  return setOnboardingFirstStepShown;
};